import BASE_URL from "../config/apiConfig";

export const UnitService = {
  // Function to get the auth token from session storage
  getAuthToken() {
    return sessionStorage.getItem("jwt");
  },

  async fetchUnitsByPropertyId(propertyId: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Unit/${propertyId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch tenants");
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching tenants:", error);
      throw error;
    }
  },

  // Add or update property data (POST)
  async postUnit(unitData: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Unit/AddUnit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify(unitData),
      });

      if (!response.ok) {
        throw new Error("Failed to create unit");
      }

      return await response.json();
    } catch (error) {
      console.error("Error posting unit:", error);
      throw error;
    }
  },

  async updateUnit(unitData: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Unit/${unitData.unitId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify(unitData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to update property: ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error updating property:", error);
      throw error;
    }
  },
};
